/** Source columns the platform owns (md_system_id, MD_LDDTS, …): never editable in a mapping. */
export const isMetadataSourceColumn = (name: string | null | undefined): boolean =>
  Boolean(name?.trim().toLowerCase().startsWith("md_"));
